import Mobix from './Mobix';

export default Mobix;
